import { Link } from "react-router-dom";
import { Badge } from "react-bootstrap";
import { Rating } from "@lomarengas/design-system";

interface CabinCardProps {
  className?: string;
  Url?: string;
  ImgSrc?: string;
  Title?: string;
  Location?: string;
  Desc?: string;
  Stars?: number;
  Horizontal?: boolean;
  BadgeText?: string;
  BadgeBg?: string;
}

const CabinCard = ({
  className,
  Url = "", // ✅ Default here
  ImgSrc = "", // ✅ Default here
  Title = "1234 Mökin nimi", // ✅ Default here
  Location,
  Desc,
  Stars,
  Horizontal,
  BadgeText,
  BadgeBg,
}: CabinCardProps) => {
  return (
    <>
      {!Horizontal ? (
        <div className={"card " + className}>
          <Link
            to={Url}
            className="d-block overflow-hidden ratio ratio-3x2 card-img-top bg-light"
          >
            {!ImgSrc || <img alt="" className="" src={ImgSrc} />}
          </Link>
          <div className="card-body p-16 p-lg-24">
            {!BadgeText || (
              <div className="position-relative">
                <Badge
                  bg={BadgeBg}
                  className="badge-sm position-absolute top-0 mt-n32"
                >
                  {BadgeText}
                </Badge>
              </div>
            )}
            <Link to={Url} className="h6 link-blue d-block mb-0">
              {Title}
            </Link>
            {!Stars || <Rating Rating={Stars} />}
            {!Location || <span className="d-block small">{Location}</span>}
            {!Desc || <span className="d-block text-muted small">{Desc}</span>}
          </div>
        </div>
      ) : (
        <div className={"card  " + className}>
          <div className="row g-0">
            <div className="col-3 col-lg-2">
              <Link
                to={Url}
                className="d-block overflow-hidden ratio ratio-3x2 h-100 rounded-start bg-light"
              >
                {!ImgSrc || (
                  <img alt="" className="object-fit-cover" src={ImgSrc} />
                )}
              </Link>
            </div>
            <div className="col">
              <div className="card-body p-16 p-lg-24">
                {!BadgeText || (
                  <div className="position-relative">
                    <Badge
                      bg={BadgeBg}
                      className="badge-sm position-absolute top-0 mt-n32"
                    >
                      {BadgeText}
                    </Badge>
                  </div>
                )}
                <Link to={Url} className="h6 link-blue d-block mb-0">
                  {Title}
                </Link>
                {!Stars || <Rating Rating={Stars} />}
                {!Location || <span className="d-block small">{Location}</span>}
                {!Desc || (
                  <span className="d-block text-muted small">{Desc}</span>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CabinCard;
export { CabinCard };
export type { CabinCardProps };
